export default __webpack_public_path__ + "static/media/ic_metis_24.5f428c73.svg";